import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import PropTypes from 'prop-types';
import { handleKeyDownEvent } from 'utils/utilsLogic';
import Const from "const.json";
import { SlArrowLeft } from "react-icons/sl";
import './BaseChart.scss'

const BaseChart = ({ chartType, data, options, plugins, componentClick, onChartCreated, ariaLabel, onDetailClick = null, isHaveDetail = false }) => {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);
    const [labelPositions, setLabelPositions] = useState([]);

    const updateLabelPositions = () => {
        if (chartInstanceRef.current) {
            const meta = chartInstanceRef.current.getDatasetMeta(0);
            const yScale = chartInstanceRef.current.scales['y-axis-0'] || chartInstanceRef.current.scales['y'];
            if (!yScale) return;
            const positions = meta.data.map((dataPoint) => {
                const x = dataPoint.x + dataPoint.width / 2;
                const y = yScale.getPixelForValue(0) + 40; // 10px below the X-axis
                return { x, y };
            });
            setLabelPositions(positions);
        }
    };


    useEffect(() => {
        const ctx = chartRef.current.getContext('2d');

        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
        }

        chartInstanceRef.current = new Chart(ctx, {
            type: chartType,
            data,
            options: {
                ...options,
                onClick: componentClick,
                onResize: updateLabelPositions,
            },
            plugins,
        });
        updateLabelPositions();



        if (onChartCreated) {
            onChartCreated(chartInstanceRef.current);
        }
        chartInstanceRef.current.options.animation.onComplete = updateLabelPositions;

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [chartType, data, options, plugins, componentClick, onChartCreated]);

    BaseChart.propTypes = {
        chartType: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        options: PropTypes.object,
        plugins: PropTypes.array,
        componentClick: PropTypes.func,
        onChartCreated: PropTypes.func
    };

    return (
        <div className='chart-wrapper' style={{ position: 'relative' }}>
            <canvas ref={chartRef} role="img" aria-label={`${Const.chartOf} ${ariaLabel}`}></canvas>

            {/* only for specific bar chart  */}
            {isHaveDetail && <div style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', width: '100%', height: '100%' }}>
                {data.labels.map((label, index) => (
                    <div className="chart-detail-link"
                        tabIndex={0}
                        key={index}
                        style={{
                            position: 'absolute',
                            top: `${labelPositions[index]?.y ?? 0}px`,
                            left: `${labelPositions[index]?.x ?? 0}px`,
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'auto',
                            cursor: 'pointer',
                        }}
                        onKeyDown={(event) => handleKeyDownEvent(event, () => onDetailClick(index))}
                        onClick={() => { onDetailClick(index) }}
                        aria-label={`${Const.forExpansion} ${label}`}
                    >{Const.forExpansion} <SlArrowLeft /></div>
                ))}
            </div>}
        </div>
    );
};

export default BaseChart;
